import { Box, Stack, styled } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'

export const Head = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.75, 2),
  borderRadius: 8,
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  backgroundColor: getThemeColor(theme, MUIThemeColors.backgroundMain),
}))

export const Stats = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
  gap: theme.spacing(1.25),
  [theme.breakpoints.down('md')]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' },
}))

export const Stat = styled(Box, { shouldForwardProp: prop => prop !== 'tone' })<{ tone: MUIThemeColors }>(
  ({ theme, tone }) => ({
    padding: theme.spacing(1.1, 1.5),
    borderRadius: 6,
    border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
    borderTop: `3px solid ${getThemeColor(theme, tone)}`,
    backgroundColor: getThemeColor(theme, MUIThemeColors.white),
    '& b': { display: 'block', fontSize: 22, lineHeight: 1.15, fontWeight: 700, color: getThemeColor(theme, tone) },
    '& span': { fontSize: 11.5, fontWeight: 500, color: getThemeColor(theme, MUIThemeColors.secondaryDark) },
  }),
)

export const CountChip = styled('span')(({ theme }) => ({
  display: 'inline-block',
  minWidth: 20,
  padding: theme.spacing(0.125, 0.875),
  borderRadius: 4,
  fontSize: 11,
  fontWeight: 600,
  textAlign: 'center',
  color: getThemeColor(theme, MUIThemeColors.white),
  backgroundColor: getThemeColor(theme, MUIThemeColors.primaryMain),
}))

export const ProgressBar = styled(Box)(({ theme }) => ({
  flex: 1,
  height: 8,
  borderRadius: 4,
  overflow: 'hidden',
  backgroundColor: getThemeColor(theme, MUIThemeColors.secondaryLight),
  '& > i': { display: 'block', height: '100%', backgroundColor: getThemeColor(theme, MUIThemeColors.successMain) },
}))

// Header and rows use display: contents so every cell sits in the table's single grid.
export const GridTable = styled(Box, { shouldForwardProp: prop => prop !== 'columns' })<{ columns: number }>(
  ({ columns }) => ({
    display: 'grid',
    gridTemplateColumns: `minmax(110px, 0.7fr) repeat(${columns}, minmax(140px, 1fr))`,
    fontSize: 12.5,
    minWidth: 520,
  }),
)

export const GridRow = styled(Box, { shouldForwardProp: prop => prop !== 'header' })<{ header?: boolean }>(
  ({ theme, header }) => ({
    display: 'contents',
    '& > *': {
      padding: theme.spacing(0.875, 1.75),
      borderTop: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
      fontWeight: header ? 600 : 500,
      fontSize: header ? 11.5 : 12.5,
      overflowWrap: 'anywhere',
      color: header ? getThemeColor(theme, MUIThemeColors.secondaryDark) : undefined,
      backgroundColor: header ? getThemeColor(theme, MUIThemeColors.backgroundMain) : undefined,
    },
  }),
)

export const Scroll = styled(Box)({ overflowX: 'auto' })

export const Missing = styled('span')(({ theme }) => ({
  fontStyle: 'italic',
  color: getThemeColor(theme, MUIThemeColors.secondaryMain),
}))
